import React from 'react'
import { Link } from 'react-router-dom'
import { IoMdInformationCircle } from "react-icons/io";
import { FaStar } from "react-icons/fa";
import { FaCheckCircle } from "react-icons/fa";

const LocalServiceAds = () => {
    return (
        <>
            <section className='local_service'>
                <div className="container">
                    <div className='guides_wrapper'>
                        <ul className="local_serv_list">
                            <li><Link to="/us">Guides</Link></li>
                            <li><Link to="/us">Digital Marketing</Link></li>
                            <li><Link to="/us/local-seo-packages">Local SEO</Link></li>
                            <li><Link to="/us/seo-services">SEO</Link></li>
                            <li><Link to="/us/ppc-marketing">Pay Per Click </Link></li>
                            <li><Link to="/us/social-media-marketing">Social Media</Link></li>
                        </ul>
                        <p>Undoubtedly, it is imperative for businesses to garner customer attention. At EZ Marketing Agency, we believe in offering solutions that make a difference. One effective way to achieve this is through Local Services Ads (LSAs) and the Google Guarantee program.</p>

                        <p>In this comprehensive guide, we will focus on LSAs and explore the benefits, requirements, management strategies, and how they can help your business:</p>

                        <h2>What are Local Services Ads?</h2>
                        <h3>40+ Plumbers  nearby <span>Sponsers <IoMdInformationCircle className='info_icon' /></span></h3>
                        <div className='row mb-5'>
                            <div className='col-12 col-sm-12 col-md-4'>
                                <div className='ads_col_wrap'>
                                    <h4>griffin service</h4>
                                    <div className='rating'>
                                        <span>5.0</span>
                                        <FaStar className='five-star' />
                                        <FaStar className='five-star'/>
                                        <FaStar className='five-star'/>
                                        <FaStar className='five-star'/>
                                        <FaStar className='five-star'/>
                                        <span className="review">
                                            see reviews
                                        </span>
                                    </div>
                                    <p><FaCheckCircle className='review_chack' />GOOGLE GUARANTEED<br/>Serves Jacksonville Open 24/7 </p>
                                </div>
                            </div>
                            <div className='col-12 col-sm-12 col-md-4'>
                            <div className='ads_col_wrap'>
                                    <h4>griffin service</h4>
                                    <div className='rating'>
                                        <span>5.0</span>
                                        <FaStar className='five-star'/>
                                        <FaStar className='five-star'/>
                                        <FaStar className='five-star'/>
                                        <FaStar className='five-star'/>
                                        <FaStar className='five-star'/>
                                        <span className="review">
                                            see reviews
                                        </span>
                                    </div>
                                    <p><FaCheckCircle className='review_chack' /> GOOGLE GUARANTEED<br/>Serves Jacksonville Open 24/7</p>
                                </div>
                            </div>
                            <div className='col-12 col-sm-12 col-md-4'>
                            <div className='ads_col_wrap'>
                                    <h4>griffin service</h4>
                                    <div className='rating'>
                                        <span>5.0</span>
                                        <FaStar className='five-star'/>
                                        <FaStar className='five-star'/>
                                        <FaStar className='five-star'/>
                                        <FaStar className='five-star'/>
                                        <FaStar className='five-star'/>
                                        <span className="review">
                                            see reviews
                                        </span>
                                    </div>
                                    <p><FaCheckCircle className='review_chack'/> GOOGLE GUARANTEED<br/>Serves Jacksonville Open 24/7</p>
                                </div>
                            </div>
                        </div>
                        <p>Local Service Ads (LSAs) are an impactful advertising tool offered by Google, specifically designed for service-based businesses. These ads appear at the top of Google’s search results, ensuring your business is prominently displayed when potential customers search for services relevant to your industry.</p>
                        
                    </div>

                </div>
            </section>
        </>
    )
}

export default LocalServiceAds